import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { CopyService } from 'src/app/shared/services/copies/copy.service';
import { HeaderService } from 'src/app/shared/services/header/header.service';
import { NavigationService } from 'src/app/shared/services/navigation/navigation-onboarding.service';
import { AbreCuentasService } from 'src/app/shared/services/abre-cuentas/abre-cuentas.service';
import { ParametersService } from 'src/app/shared/services/parameters/parameters.service';
import { OpEnum } from 'src/app/shared/enums/op.enum';
import { BUSINESS_CONST } from 'src/app/shared/constants/business.constants';
import { navCode } from 'src/app/shared/constants/channel.constants';

@Component({
  selector: 'app-outlay-other-bank',
  templateUrl: './outlay-other-bank.component.html',
  styleUrls: ['./outlay-other-bank.component.scss'],
})
export class OutlayOtherBankComponent implements OnInit {

  formGroup: FormGroup;
  options: string[];
  options2: string[];
  showOptions: boolean;
  banco: any;
  cuenta: any;
  tipo: any;
  constructor(
    public copyService: CopyService,
    private navigationService: NavigationService,
    private headerService: HeaderService,
    private formBuilder: FormBuilder,
    private abreCuentasService: AbreCuentasService,
    private parameterService: ParametersService,
  ) {
    this.headerService.show(true, true, true);
    this.formGroup = this.formBuilder.group({});
    this.showOptions = false;
  }

  ngOnInit() {
    const otherBankAccount = this.abreCuentasService.getSavedOtherBank();
    if (otherBankAccount) {
      this.formGroup = new FormGroup({
        banco: new FormControl(otherBankAccount.bank_id, [Validators.required]),
        tipocuenta: new FormControl(otherBankAccount.account_type, [Validators.required]),
        numerocuenta: new FormControl(otherBankAccount.account_id, [Validators.required]),
      });
    } else {
      this.formGroup = new FormGroup({
        banco: new FormControl('', [Validators.required]),
        tipocuenta: new FormControl('', [Validators.required]),
        numerocuenta: new FormControl('', [Validators.required]),
      });
    }
    this.options = this.parameterService.getSetting(OpEnum.OUTLAY_OTHER_BANKS);
    this.options2 = ['Cuenta de ahorros', 'Cuenta corriente'];
  }

  next() {
    this.abreCuentasService.setSavedOtherBank({
      account_id: this.formGroup.value['numerocuenta'],
      account_type: this.formGroup.value['tipocuenta'],
      bank_id: this.formGroup.value['banco'],
    });
    this.updateOfficeDisbursement();
    this.navigation();
  }

  navigation() {
    if (this.abreCuentasService.viewOptionMultiProduct) {
      this.navigationService.nextStep(this.navigationService.nextMulti(this.abreCuentasService.getProductsSelects()));
    } else {
      this.navigationService.nextStep(navCode[200]);
    }
  }

  updateOfficeDisbursement() {
    let disbursement = this.abreCuentasService.getDisbursementInfo();
    disbursement.forEach(Productos => {
      Productos.refund.forEach(method => {
        if (method.refund_method === BUSINESS_CONST.ACH) {
          console.log(this.formGroup.value['tipocuenta']);
          method.account = {
            account_id: this.formGroup.value['numerocuenta'],
            account_type: this.formGroup.value['tipocuenta'] === BUSINESS_CONST.ACCOUNT ? BUSINESS_CONST.AHO : BUSINESS_CONST.CO,
            account_subtype: this.abreCuentasService.getStatusCreate() ? this.copyService.copies.create_account : '',
          };
          method.branch_id = '';
          method.bank_id = this.formGroup.value['banco'].code;
        }
      });
    });
    this.abreCuentasService.setDisbursementInfo(disbursement);
  }

}
